<ng-container *ngIf="!disableSearch()">
  <yo-search-panel></yo-search-panel>
</ng-container>
<router-outlet></router-outlet>
